<template>
  <div>
    <el-dropdown
      class="avatar-container right-menu-item hover-effect"
      trigger="click"
      @command="handleCommand"
    >
      <div class="avatar-wrapper">
        <img :src="getInfo().avatar || img.DefaultAvatar" class="user-avatar" />
        <i class="el-icon-caret-bottom" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <template>
          <el-dropdown-item>{{ getInfo().fullname }}</el-dropdown-item>
        </template>
        <el-dropdown-item divided @click.native="$router.push('/my-courses')">
          <span style="display:block;">Your course</span>
        </el-dropdown-item>
        <el-dropdown-item divided @click.native="logout">
          <span style="display:block;">Logout</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { getToken, getInfo } from "@/utils/auth";
import DefaultAvatar from "@/assets/img/DefaultAvatar.png";
import store from "@/store";
export default {
  name: "badge",
  props: {},
  methods: {
    handleCommand() {},
    async logout() {
      store.dispatch("user/resetToken").then(() => {
        location.reload();
        // store.dispatch('showLoginDialog');
      });
    },
    getInfo
  },
  data() {
    return {
      img: {
        DefaultAvatar
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom;

  &.hover-effect {
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
}

.avatar-container {
  .avatar-wrapper {
    position: relative;

    .user-avatar {
      cursor: pointer;
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }

    .el-icon-caret-bottom {
      cursor: pointer;
      position: absolute;
      right: -15px;
      top: 25px;
      font-size: 12px;
    }
  }
}
</style>
